import { ChromeVideoEngine } from './ChromeVideoEngine';
import { StandardVideoEngine } from './StandardVideoEngine';
export function createVideoEngine() {
    // On chrome MediaStreamTrackProcessor in window object
    const engineType = typeof MediaStreamTrackProcessor !== 'undefined'
        ? 'Chrome'
        : 'Standard';
    if (engineType === 'Chrome') {
        return new ChromeVideoEngine();
    }
    return new StandardVideoEngine();
}
